import styles from "./About.module.css";
import PersonCard from "../../components/PersonCard/PersonCard";

function About() {
  return (
    <section className={styles.about}>
      <div className={styles.heroContainer}>
        <div className={styles.heroImg}></div>
        <div className={styles.heroOverlay}>
          <h1 className={styles.heroTitle}>Sobre Nosotros</h1>
          <p className={styles.heroDescription}>
            Conoce nuestra historia, nuestro equipo y nuestra visión
          </p>
        </div>
      </div>
      <div className={styles.historyContainer}>
        <h2 className={styles.historySubtitle}>Historia</h2>

        <h3 className={styles.sectionTitle}>Nuestro Comienzo</h3>
        <p className={styles.sectionText}>
          El 16 de noviembre de 2018, un grupo de 10 familias con hijos
          diagnosticados con Trastorno del Espectro Autista (TEA) de la comuna
          de La Calera y sus alrededores, se unieron con un propósito común:
          mejorar la calidad de vida de sus niños. La necesidad era clara y
          urgente: había una alta demanda de servicios especializados en salud
          para niños autistas, pero el costo de estos servicios profesionales
          era prohibitivamente alto para muchas familias.
        </p>

        <h3 className={styles.sectionTitle}>
          Nuestro Modelo de Financiamiento
        </h3>
        <p className={styles.sectionText}>
          Así nació <strong>IMPERIO TEA</strong>, una corporación sin fines de
          lucro diseñada para brindar apoyo y recursos a estas familias. Desde
          sus inicios, IMPERIO TEA ha operado bajo un modelo de financiamiento
          comunitario. Las familias que forman parte de la corporación han sido
          fundamentales en la recaudación de fondos. Los métodos de recaudación
          incluyen:
        </p>
        <ul className={styles.sectionList}>
          <li className={styles.listItem}>
            <strong>Venta de Platos Únicos:</strong> Deliciosamente preparados y
            vendidos en eventos comunitarios.
          </li>
          <li className={styles.listItem}>
            <strong>Rifas:</strong> Organizadas durante reuniones periódicas.
          </li>
        </ul>
        <p className={styles.sectionText}>
          Estas actividades no solo sirven para financiar las operaciones de la
          corporación sino que también fortalecen el sentido de comunidad y
          apoyo entre las familias.
        </p>

        <h3 className={styles.sectionTitle}>Nuestro Crecimiento</h3>
        <p className={styles.sectionText}>
          A lo largo de los años, <strong>IMPERIO TEA</strong> ha crecido y se
          ha consolidado gracias al esfuerzo de todos. Hoy en día, contamos con
          un equipo de profesionales dedicados que reciben los recursos
          necesarios para llevar a cabo sesiones de terapia de alta calidad.
          Desde terapias ocupacionales hasta sesiones de lenguaje y
          comportamiento, cada niño recibe un tratamiento personalizado según
          sus necesidades específicas.
        </p>
        <p className={styles.sectionText}>
          Hoy en día, IMPERIO TEA no solo ofrece terapias sino que también ha
          mejorado la infraestructura para asegurar que las sesiones se realicen
          en un ambiente adecuado y estimulante. Además, la corporación ha
          podido adquirir herramientas y materiales didácticos que facilitan el
          trabajo de los terapeutas, asegurando que cada sesión no solo sea
          efectiva sino también enriquecedora para los niños.
        </p>

        <h3 className={styles.sectionTitle}>Nuestra Visión</h3>
        <p className={styles.sectionText}>
          La corporación sigue siendo una luz de esperanza y apoyo para muchas
          familias, demostrando que con esfuerzo, solidaridad y una visión
          clara, es posible superar las barreras económicas y de acceso a
          servicios de salud especializados para niños con autismo.{" "}
          <strong>IMPERIO TEA</strong> se ha convertido en un ejemplo de cómo la
          comunidad puede unir fuerzas para hacer una diferencia real en la vida
          de sus miembros más vulnerables.
        </p>
      </div>
      <div className={styles.PersonContainer}>
        <h2 className={styles.personTitle}>Nuestro Equipo</h2>
        <h3 className={styles.proSubtitle}>Profesionales</h3>
        <div className={styles.personCardContainer}>
          <PersonCard
            datos="Formación académica"
            name="Cecilia Díaz Guajardo"
            profession="Terapeuta Ocupacional especializada en infancia"
            img="/images/people/ceci.webp"
            alt="Cecilia Díaz Guajardo, Terapeuta Ocupacional especializada en infancia, posando frente a una puerta blanca con un uniforme con estampado de Minnie Mouse."
            description={
              "Terapeuta Ocupacional - Universidad de Playa Ancha\n" +
              "Diplomado experto en autismo - Hyperpraxis\n" +
              "Diplomado en NANEAS y sus familias - Sociedad Chilena de Pediatría\n" +
              "Diplomado en neurorrehabilitación infantil - Universidad Autónoma de Chile\n" +
              "Curso de teoría de integración sensorial - Corporación Chilena de IS\n" +
              "Curso de selectividad alimentaria - OTEC Movilizate"
            }
          />
          <PersonCard
            datos="Formación académica"
            name="John Iglesias Pérez"
            profession="Fonoaudiólogo"
            img="\images\people\john.webp"
            alt="John Iglesias Pérez, Fonoaudiólogo, posando frente a un fondo de pared blanca."
            description={
              "Formación en Condición del Espectro Autista\n" +
              "Formación en Apraxia del Habla Infantil\n" +
              "Formación en Voz y Motricidad Orofacial\n" +
              "Certificado IDTEL\n" +
              "Certificado Internacional en ADOS-2\n" +
              "Certificado en Intervención DTTTC\n" +
              "Otoscopía y Lavado de Oídos"
            }
          />
          <PersonCard
            datos="Formación académica"
            name="Macarena Escobar Coccio"
            profession="Fonoaudióloga"
            img="\images\people\macarena.webp"
            alt="Macarena Escobar Cocio, Fonoaudióloga, posando frente a una puerta de madera con un uniforme decorado con personajes de Winnie the Pooh."
            description={
              "Evaluación, diagnóstico e intervención del lenguaje, habla y comunicación.\n" +
              "Enfocada en trastorno del Espectro Autista, inicio tardío y trastornos del lenguaje.\n" +
              "Diplomada en Neurociencia Educativa.\n" +
              "Con Formación en Estrategias de Intervención temprana en Tea.\n" +
              "Con Formación en Intervención Cognitiva y Lingüística en infancia temprana.\n" +
              "Certificada en aplicación de IDTEL (Instrumento de Diagnóstico para los trastornos Específicos del Lenguaje)."
            }
          />
          <PersonCard
            datos="Formación académica"
            name="Ornella Maldonado"
            profession="Psicóloga Clínica"
            img="\images\people\ornella.webp"
            alt="Ornella Maldonado, Psicóloga Clínica, posando frente a un fondo no visible."
            description={
              "Diplomada en psico diagnóstico Infanto-Juvenil\n" +
              "Acreditación Oficial Clínica Internacional ADOS-2\n" +
              "Certificación Avanzada en WISC-V y ADI-R\n"
            }
          />
          <PersonCard
            datos="Formación académica"
            name="Maricela González"
            profession="Educadora Diferencial"
            img="\images\people\maricela.webp"
            alt="Maricela González, Educadora Diferencial, posando frente a un fondo de madera con un espejo decorativo."
            description={
              "Psicopedagoga licenciada en eduación\n" +
              "Especialista en:\n" +
              "Dificultades de aprendizaje - TEA - NEE\n" +
              "Adquisición a la lecto escritura y cálculo\n" +
              "Estrategias de comprensión lectora\n" +
              "Atención temprana a niños(as) que presenten alguna NEE desde los 2 años\n"
            }
          />
          <PersonCard
            datos="Formación académica"
            name="Javiera Villarroel López"
            profession="Terapeuta Ocupacional"
            img="\images\people\javiera.webp"
            alt="Javiera Villarroel López, Terapeuta Ocupacional, posando frente a un fondo blanco."
            description={
              "Licenciada en Ocupación Humana\n" +
              "Certificada en:\n" +
              "Transtornos del Neurodesarrollo\n" +
              "Salud mental Infanto-Juvenil\n" +
              "Transtorno del espectro autista\n" +
              "Estrategias de integración sensorial\n"
            }
          />
          <PersonCard
            datos="Formación académica"
            name="Marisol Fernanda Muñoz Zamora"
            profession="Fonoaudióloga"
            img="\images\people\marisol.webp"
            alt="Marisol Muñoz, Fonoaudióloga, posando frente a un fondo blanco."
            description={
              "Evaluación, diagnóstico e intervención del lenguaje, habla y comunicación.\n" +
              "⁠Acreditación clínica internacional ADOS-2 para la observación diagnóstica del Trastorno del Espectro Autista.\n" +
              "Formación en detección temprana e intervención cognitiva, lingüística y comunicativa en TEA.\n" +
              "Formación en Programa CLAP: comunicación, lenguaje, articulación y pensamiento.\n" +
              "Diplomado en Neurociencia Educativa.\n" +
              "⁠Capacitación en aplicación del Instrumento Diagnóstico para los Trastornos Específicos del Lenguaje (IDTEL).\n"
            }
          />
          <PersonCard
            datos="Formación académica"
            name="Jovanna Saavedra Athuan"
            profession="Terapeuta Ocupacional"
            img="\images\people\jovanna.webp"
            alt="Jovanna Saavedra Athuan, Terapeuta Ocupacional, posando frente a un fondo de madera con un delantal celeste."
            description={
              "Licenciada en ciencias de la ocupación humana por la Universidad de Playa Ancha\n" +
              "Diplomada en evaluación e intervención en trastornos del espectro autista - Consultorio Médico de neurociencia cognitiva y clínica Chile\n" +
              "Diplomada en terapia ABA para autismo y otros trastornos del desarrollo - Corporación internacional líderes Latino América\n" +
              "Diplomada en inclusión y diversidad - Fundación Telefónica y Fundación 'La Caixa'\n" +
              "Certificada en aplicación de ADOS - 2 por el consultorio médico de neurociencia cognitiva y clínica Chile y en aplicación de IVADEC por COMPIN\n" +
              "Con formación en:\n" +
              "- Dificultades del Aprendizaje en autismo y TDAH a lo largo del ciclo vital\n" +
              "- Desarrollo de la motricidad fina y grafomotricidad en la primera infancia\n" +
              "- El juego como herramienta terapéutica\n"
            }
          />
        </div>
        <h3 className={styles.directiveSubtitle}>Directiva</h3>
        <div className={styles.personCardContainer}>
          <PersonCard
            datos="Información de contacto"
            name="Cesar Antonio Espinoza Gonzalez"
            profession="Presidente"
            img="\images\people\cesar.webp"
            alt="Cesar Antonio Espinoza González, Presidente de Imperio TEA, posando frente a un fondo de madera."
            description={
              "*Solo mensajes al WhatsApp*\n "+"+569 1234 5678\n" +
              "Presidente.Imperiotea@gmail.com\n"
            }
          />
        </div>
      </div>
    </section>
  );
}
export default About;
